import { render, staticRenderFns } from "./EditExclusive.vue?vue&type=template&id=2abc4116"
import script from "./EditExclusive.vue?vue&type=script&lang=js"
export * from "./EditExclusive.vue?vue&type=script&lang=js"
import style0 from "./EditExclusive.vue?vue&type=style&index=0&id=2abc4116&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports